import Redeem from './Redeem.gql';

export default Redeem;
